import { BoxProps } from '@chakra-ui/react';
import * as React from 'react';

import { Footer, FooterButton, FooterButtonLabel } from '@/components/Footer';
import { useMemberManagement } from '@/hooks/useMemberManagement';
import {
  AwardIcon,
  CreditCardIcon,
  LockIcon,
  ShoppingBagIcon,
  StarIcon,
  ToolIcon,
  UserIcon,
} from '@/imports/ui/chakra/feather';

import { tokenStorage } from '../../../../modules/accounts/tokenStorage';

export const HummusMobileNavigation: React.FC<BoxProps> = (props) => {
  const memberManagement = useMemberManagement();

  return (
    <Footer {...props}>
      <FooterButton href="/me/profile">
        <UserIcon boxSize="5" />
        <FooterButtonLabel>Profile</FooterButtonLabel>
      </FooterButton>

      {memberManagement.isActive && !tokenStorage.getItem('isMobile') && (
        <>
          <FooterButton href="/me/membership">
            <AwardIcon boxSize="5" />
            <FooterButtonLabel>Membership</FooterButtonLabel>
          </FooterButton>
          <FooterButton href="/me/payment">
            <CreditCardIcon boxSize="5" />
            <FooterButtonLabel>Payment</FooterButtonLabel>
          </FooterButton>
        </>
      )}

      <FooterButton href="/me/orders">
        <ShoppingBagIcon boxSize="5" />
        <FooterButtonLabel>Orders</FooterButtonLabel>
      </FooterButton>
      <FooterButton href="/me/notifications">
        <ToolIcon boxSize="5" />
        <FooterButtonLabel>Notifications</FooterButtonLabel>
      </FooterButton>
      <FooterButton href="/me/privacy">
        <LockIcon boxSize="5" />
        <FooterButtonLabel>Privacy</FooterButtonLabel>
      </FooterButton>
      <FooterButton href="/me/badges">
        <StarIcon boxSize="5" />
        <FooterButtonLabel>Badges</FooterButtonLabel>
      </FooterButton>
    </Footer>
  );
};
